<template><div><h1>VUX V2.2.1Rc.1 released</h1>
<h2><a href="/en/components/cell-box.html">CellBox</a></h2>
<ul><li>[feature] Support prop:border-intent</li>
</ul>
<h2><a href="/en/components/cell-form-preview.html">CellFormPreview</a></h2>
<ul><li>[feature] Support prop:border-intent</li>
</ul>
<h2><a href="/en/components/cell.html">Cell</a></h2>
<ul><li>[feature] Support prop:border-intent</li>
<li>[feature] Support prop:arrow-direction</li>
</ul>
<h2><a href="/en/components/checklist.html">Checklist</a></h2>
<ul><li>[feature] Support prop:check-disabled</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] Fix wrong closeType #1209</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.1 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.1-92.vue?140daa45